<template>
    <div>
        <base-input
            v-model="owner.name"
            v-validate="'required'"
            :name="$t('login.name')"
            :placeholder="$t('login.name')"
            :error="errors.first($t('login.name'))"
            type="text"
        ></base-input>
        <base-input
            v-model="owner.email"
            v-validate="'required|email'"
            :name="$t('login.email')"
            :placeholder="$t('login.email')"
            :error="errors.first($t('login.email'))"
            disabled
        ></base-input>
        <div :class="blockStudentFields===0 ? 'd-flex flex-wrap justify-content-between' : 'd-flex flex-wrap justify-content-center' ">
            <div class="col-md-6 pl-0" :class="$mq === 'sm' ? 'pr-0 mb-2' : ''">
                <base-button
                    class="col-12 mr-0"
                    type="warning"
                    @click="$emit('changePassword', owner)"
                >{{$t('login.password.change.title')}}
                </base-button>
            </div>
            <change-email
                v-if="blockStudentFields===0"
                class="col-md-6 pr-0"
                :class="$mq === 'sm' ? 'pl-0 mb-2' : ''"
                :color="color"
                :user-id="owner.id"
            ></change-email>
        </div>
    </div>
</template>

<script>
import ChangeEmail from './ProfileChangeEmail'

import BaseInput from '../../argon/components/Inputs/BaseInput'
import BaseButton from '../../argon/components/BaseButton'

export default {
    emits: ['changePassword', 'errors', 'input', 'update:modelValue'],
    name: 'ProfileOwner',
    components: {
        ChangeEmail,
        BaseInput,
        BaseButton
    },
    props: {
        modelValue: {
            type: Object,
            required: true
        },
        color: {
            type: Object,
            required: true
        },
        blockStudentFields: {
            type: Number
        }
    },

    data() {
        return {
            disabled: this.blockStudentFields
        }
    },

    watch: {
        errorsBag(val) {
            this.$emit('errors', val)
        }
    },
    computed: {
        owner: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        },
        errorsBag() {
            return this.errors.items.length
        }
    }
}
</script>

<style>

</style>
